import { getProductFilter } from '~/features/ProductList/utils';
import { UmbracoTypes } from '~/lib/data-contract';
import useCampaignEntities from '~/services/loop54/hooks/useCampaignEntities';
import { Loop54ProductAttributes } from '~/services/loop54/types';
import { reduceLoop54Product } from '~/services/loop54/utils';

type Props = Pick<
    UmbracoTypes.IM30CampaignProductCarouselModule,
    'amountOfProducts' | 'campaignID' | 'sorting' | 'ascendingOrder' | 'onlyShowInStock'
>;

type filter = {
    type: string;
    attributeName?: Loop54ProductAttributes;
    value?: string | boolean;
};

export default function useCampaignResults({
    amountOfProducts,
    campaignID,
    sorting,
    ascendingOrder,
    onlyShowInStock,
}: Props) {
    const filters: filter[] = [
        getProductFilter(),
        {
            type: 'attribute',
            attributeName: Loop54ProductAttributes.CampaignLabelDescription,
            value: campaignID,
        },
    ];

    if (onlyShowInStock) {
        filters.push({
            type: 'attribute',
            attributeName: Loop54ProductAttributes.InStock,
            value: onlyShowInStock,
        });
    }

    return useCampaignEntities(
        {
            resultsOptions: {
                filter: {
                    and: filters,
                },
                sortBy: [
                    {
                        type: sorting,
                        order: ascendingOrder ? 'asc' : 'desc',
                        ...(sorting === 'attribute' && {
                            attributeName: Loop54ProductAttributes.ItemName,
                        }),
                    },
                ],
                take: amountOfProducts ?? 10,
            },
        },
        (data) => ({
            ...data,
            results: reduceLoop54Product(data.results),
        }),
    );
}
